'use client';

import { Button } from '@/components/ui/button';

import { APP_ROUTES } from '@/shared/constants/navigation';
import { redirectViaWindow } from '@/shared/utils/window';

import { cn } from '@/lib/utils';

import { MARKETING_PAGE, trackGetStartedClicked } from '../../utils/marketing-analytics';

type CTASectionProps = {
	page: MARKETING_PAGE;
	title?: string;
	buttonText?: string;
	className?: string;
	buttonClassName?: string;
	headingClassName?: string;
	align?: 'center' | 'left';
	/** Where the CTA lands. Defaults to plain login. */
	href?: string;
};

export const CTASection = ({
	page,
	title = 'Fall in love with hiring.',
	buttonText = 'Start for free',
	className,
	buttonClassName,
	headingClassName,
	align = 'center',
	href,
}: CTASectionProps) => {
	const isLeft = align === 'left';

	return (
		<section
			className={cn(
				'landing-width mb-24 w-full md:mb-32',
				!isLeft && 'px-4 md:mb-40 md:px-8',
				className
			)}
		>
			<div
				className={cn(
					'flex max-w-full flex-col',
					isLeft ? 'items-start' : 'items-center justify-center'
				)}
			>
				<h2
					className={cn(
						'landing-heading mb-12',
						isLeft ? 'text-left' : 'text-center',
						headingClassName
					)}
				>
					{title}
				</h2>

				<div
					className={cn(
						'flex flex-wrap items-center gap-3',
						isLeft ? 'justify-start' : 'justify-center'
					)}
				>
					<Button
						className={cn(
							'h-[48px] w-auto px-5 text-base tracking-wide transition-all hover:translate-y-0.5',
							buttonClassName
						)}
						onClick={() => {
							trackGetStartedClicked(page, 'footer');
							redirectViaWindow(href ?? `${APP_ROUTES.LOGIN}`);
						}}
					>
						{buttonText}
					</Button>
				</div>
			</div>
		</section>
	);
};
